import React, { useState } from "react";
import { Link } from "react-router-dom";

import SingleAttraction from "./SingleAttraction";

import ranczo1 from "../../assets/img/attractions/ranczo1.jpg";
import ranczo2 from "../../assets/img/attractions/ranczo2.jpg";
import glownySzlakSudecki1 from "../../assets/img/attractions/glowny-szlak-sudecki1.jpg";
import glownySzlakSudecki2 from "../../assets/img/attractions/glowny-szlak-sudecki2.jpg";
import parkZdrojowy from "../../assets/img/attractions/parkZdrojowy.jpg";
import pijalnia from "../../assets/img/attractions/duszniki-zdroj-pijalnia.jpg";
import stokNarciarski1 from "../../assets/img/attractions/zieleniec-stok-narciarski.jpg";
import stokNarciarski2 from "../../assets/img/attractions/zieleniec-stok-narciarski2.jpg";
import adrspasskeskaly from "../../assets/img/attractions/adrspasskeskaly.jpg";
import zamekNachod from "../../assets/img/attractions/zamek-nachod.jpg";
import broumovsko from "../../assets/img/attractions/broumovsko.jpg";
import pivovar from "../../assets/img/attractions/pivovar.jpg";
import szlaki1 from "../../assets/img/attractions/szlaki1.jpg";
import szlaki2 from "../../assets/img/attractions/szlaki2.jpg";
import muzeumPapiernictwa1 from "../../assets/img/attractions/muzeumPapiernictwa1.jpg";
import muzeumPapiernictwa2 from "../../assets/img/attractions/muzeumPapiernictwa2.jpg";

export default function Attractions() {
  const services = [
    "Ranczo Panderoza",
    "Główny Szlak Sudecki",
    "Park Zdrojowy",
    "Szlaki narciarskie",
    "Bliskość Czech",
    "Trasy turystyczne",
    "Muzeum papiernictwa",
  ];
  const [activeLinkIndex, setActiveLinkIndex] = useState(0);

  const onServiceNavClick = (scrollToElementId, index) => () => {
    setActiveLinkIndex(index);
    const elementToScroll = document.getElementById(scrollToElementId);
    elementToScroll.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-sm-12 col-lg-4 order-1 not-small-display sticky-top not-medium-display">
          <aside className="sidebar services-sidebar sticky-top">
            <div className="sidebar-widget categories sticky-top">
              <div className="widget-content sticky-top">
                <h2 className="widget-title">Atrakcje</h2>
                <ul className="services-categories sticky-top">
                  {services.map((service, index) => {
                    return (
                      <li
                        key={service}
                        className={index === activeLinkIndex ? "active" : ""}
                        onClick={onServiceNavClick(service, index)}
                      >
                        <Link to="#">{service}</Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </aside>
        </div>
        <div className="col-sm-12 col-lg-8 order-2 without-scrollbar">
          <SingleAttraction
            title={services[0]}
            imagesSources={[ranczo1, ranczo2]}
          >
            <p>
              <a href="http://panderozarancho.pl/" target="_blank">
                Rancho Panderoza
              </a>{" "}
              – otoczone lasami i łąkami z krystalicznie czystym powietrzem, a
              przede wszystkim pięknymi widokami. Rancho leży na trasie
              Sudeckiego Szlaku konnego o długości 360 km, który zaczyna się w
              Lądku Zdroju, a kończy w Karpaczu. Najbliższe okolice to wspaniałe
              trasy turystyczne z licznymi punktami widokowymi zarówno na konne
              wyprawy jak i piesze wędrówki. Trasy są urozmaicone, są trudne z
              karkołomnymi zjazdami i podjazdami oraz te łatwiejsze dla mniej
              zaawansowanych jeźdźców. Wszystkie je łączy jedno: przepiękne
              widoki zapierające dech w piersiach! Zimą organizowane są również
              kuligi. Wszystko to oraz możliwość jazdy na spokojnych i
              zrównoważonych koniach zapewnia niezapomniane przeżycia!
            </p>
          </SingleAttraction>
          <SingleAttraction
            title={services[1]}
            imagesSources={[glownySzlakSudecki1, glownySzlakSudecki2]}
          >
            <p>
              Zapraszamy na niezapomnianą przygodę w sercu Sudetów –{" "}
              <a
                href="https://pl.wikipedia.org/wiki/G%C5%82%C3%B3wny_Szlak_Sudecki"
                target="_blank"
              >
                Główny Szlak Sudecki
              </a>{" "}
              , jeden z najdłuższych i najbardziej malowniczych szlaków pieszych
              w Polsce. Rozciągający się na długość około 440 km, szlak
              przechodzi przez różnorodne krajobrazy, od nizinnych terenów aż po
              majestatyczne górskie szczyty. Podczas wędrówki Głównym Szlakiem
              Sudeckim, odkryjesz nie tylko spektakularne widoki, ale także
              bogatą historię i kulturę regionu. Szlak prowadzi przez znane
              pasma górskie, takie jak Karkonosze z imponującym Śnieżką,
              malownicze Góry Stołowe, czy tajemnicze Góry Wałbrzyskie, oferując
              przy tym różnorodność tras, dostosowanych zarówno dla
              doświadczonych wędrowców, jak i rodzin z dziećmi. Główny Szlak
              Sudecki to nie tylko wyzwanie fizyczne, ale przede wszystkim
              niezapomniane doświadczenie i możliwość głębokiego kontaktu z
              naturą. Czy jesteś gotowy na przygodę życia? Główny Szlak Sudecki
              czeka, by odkryć jego tajemnice!
            </p>
          </SingleAttraction>
          <SingleAttraction
            title={services[2]}
            imagesSources={[parkZdrojowy, pijalnia]}
          >
            <p>
              Zapraszamy do serca Dusznik-Zdroju, gdzie znajdziesz oazę spokoju
              i zdrowia – malowniczy{" "}
              <a href="http://panderozarancho.pl/" target="_blank">
                Park Zdrojowy
              </a>{" "}
              oraz historyczną{" "}
              <a
                href="https://gazetalubuska.pl/pijalnie-wod-mineralnych-w-polsce-czyli-podroz-po-zdrowie-gdzie-mozna-napic-sie-leczniczej-wody-ktore-pijalnie-sa-darmowe-ktore/gh/c7-17072763/3"
                target="_blank"
              >
                {" "}
                Pijalnię Wód
              </a>
              . To miejsce, gdzie tradycja łączy się z naturą, oferując
              odwiedzającym nie tylko wypoczynek, ale i naturalne metody poprawy
              zdrowia. Park Zdrojowy w Dusznikach-Zdroju to prawdziwy klejnot
              architektoniczny i przyrodniczy. Spacerując po jego alejkach,
              możesz podziwiać starannie pielęgnowane rabaty kwiatowe, zabytkowe
              budowle oraz słynne fontanny. Ten zielony zakątek stanowi idealne
              miejsce do relaksu i odprężenia, zarówno dla kuracjuszy, jak i
              turystów szukających spokoju. Główną atrakcją parku jest Pijalnia
              Wód, zbudowana w XIX wieku. To tutaj możesz skosztować leczniczych
              wód mineralnych, które od wieków są wykorzystywane w leczeniu
              różnych dolegliwości. Elegancki, neorenesansowy budynek pijalni to
              nie tylko miejsce degustacji wód, ale również centrum życia
              kulturalnego Dusznik-Zdroju, z koncertami i wystawami.
              Duszniki-Zdrój to nie tylko lecznictwo, ale i bogata historia,
              którą można odkrywać na każdym kroku. Park Zdrojowy i Pijalnia Wód
              to serce tego urokliwego miasta, miejsce, gdzie historia, kultura
              i natura tworzą wyjątkową harmonię. Odwiedź Duszniki-Zdrój i
              doświadcz wyjątkowej atmosfery tego miejsca, gdzie zdrowie i
              relaks idą w parze z pięknem i historią.
            </p>
          </SingleAttraction>
          <SingleAttraction
            title={services[3]}
            imagesSources={[stokNarciarski1, stokNarciarski2]}
          >
            <p>
              <a
                href="https://www.duszniki.com.pl/atrakcje/osrodek-narciarski-zieleniec"
                target="_blank"
              >
                Zieleniec
              </a>{" "}
              to znany, największy w Ziemi Kłodzkiej, ośrodek narciarski, jeden
              z większych w Sudetach. Jednocześnie Zieleniec to dzielnica
              Dusznik-Zdroju. Panują tutaj wyśmienite warunki narciarskie -
              średniorocznie śnieg leży tu przez 150 dni rocznie, panuje klimat
              podobny do tego w Alpach. Na narciarzy czeka ponad 30 różnego
              rodzaju wyciągów, w tym nowoczesne wyciągi 4 i 6-osobowe. Wyciągi
              i trasy narciarskie nie wykorzystują tylko jednego stoku - to cały
              kompleks. Stopniem trudności dopasowane są dla narciarzy na każdym
              poziomie umiejętności - od tak zwanej oślej łączki po trudne,
              profesjonalne trasy narciarskie. Na stokach Orlicy rozgrywane są
              wyścigi psich zaprzęgów. Do Zieleńca warto przyjechać nie tylko
              zimą i nie tylko na narty. To dobra baza wypadowa do wędrówek po
              górach Orlickich i Bystrzyckich. Ze względu na bliskość czeskiej
              granicy, można także wędrować po czeskiej stronie Sudetów.
            </p>
          </SingleAttraction>
          <SingleAttraction title={services[4]} withBottomBorder={false}>
            <p>
              Położeni w malowniczym Dusznikach-Zdroju, jesteśmy nie tylko bramą
              do polskich atrakcji uzdrowiskowych i naturalnych, ale także
              zaledwie 1,2 km od czarującej granicy z Czechami. Nasz hotel
              stanowi idealne miejsce wypadowe dla tych, którzy pragną połączyć
              relaks w Polsce z odkrywaniem czeskich pereł.
            </p>
            <h5>Czeskie Atrakcje na Wyciągnięcie Ręki</h5>
            <p className="without-bottom-margin">
              Podczas pobytu u nas, zachęcamy do przekroczenia granicy i
              zanurzenia się w bogatej kulturze i historii naszych czeskich
              sąsiadów. Oto kilka atrakcji, które warto odwiedzić:
            </p>
          </SingleAttraction>
          <SingleAttraction
            withBottomBorder={false}
            imagesSources={[adrspasskeskaly, zamekNachod]}
          >
            <ol>
              <li>
                <a
                  style={{ fontWeight: "bold" }}
                  href="https://www.adrspasskeskaly.cz/"
                  target="_blank"
                >
                  Adršpašsko-teplické skály
                </a>{" "}
                - te spektakularne formacje skalne, znajdujące się zaledwie
                godzinę jazdy od Dusznik-Zdroju, oferują niezapomniane widoki i
                szlaki turystyczne. Idealne dla miłośników przyrody i
                fotografii.
              </li>{" "}
              <li>
                <a
                  style={{ fontWeight: "bold" }}
                  href="https://www.zamek-nachod.cz/pl"
                  target="_blank"
                >
                  Hrad Náchod
                </a>{" "}
                - ten imponujący zamek w Náchodzie, położony zaledwie 30 minut
                od naszego hotelu, przeniesie Was w czasie do epoki rycerzy i
                królewskich intryg.
              </li>
            </ol>
          </SingleAttraction>
          <SingleAttraction imagesSources={[broumovsko, pivovar]}>
            <ol>
              <li>
                <a
                  style={{ fontWeight: "bold" }}
                  href="https://www.region-adrspach.cz/broumovske-steny/"
                  target="_blank"
                >
                  Broumovské stěny
                </a>{" "}
                - cudowny obszar chronionego krajobrazu, który zaprasza do
                pieszych wędrówek pośród malowniczych skał i zielonych dolin.
              </li>{" "}
              <li>
                <a
                  style={{ fontWeight: "bold" }}
                  href="https://primator.cz/2023/01/01/wycieczka-do-browaru-nachod/"
                  target="_blank"
                >
                  Pivovar Náchod
                </a>{" "}
                - dla miłośników złocistego trunku, wycieczka do browaru w
                Náchodzie to okazja do degustacji lokalnych piw i poznania
                tajników ich produkcji. Kuks Hospital - Ten barokowy kompleks
                szpitalno-pałacowy, słynący z unikatowych
              </li>
              <li>
                <a
                  style={{ fontWeight: "bold" }}
                  href="https://www.hospital-kuks.cz/cs"
                  target="_blank"
                >
                  Kuks Hospital
                </a>{" "}
                - ten barokowy kompleks szpitalno-pałacowy, słynący z
                unikatowych rzeźb Matyasa Brauna, to prawdziwa perła
                architektury.
              </li>
            </ol>
          </SingleAttraction>
          <SingleAttraction
            title={services[5]}
            imagesSources={[szlaki1, szlaki2]}
          >
            <p>
              Duszniki-Zdrój, położone w sercu malowniczych Gór Stołowych,
              stanowią idealną bazę wypadową dla miłośników pieszych wędrówek.
              Otoczone nieskazitelną przyrodą i bogatą historią, nasze okolice
              oferują szereg fascynujących tras turystycznych, które zadowolą
              zarówno początkujących, jak i doświadczonych miłośników górskich
              eskapad.
            </p>
            <p>
              Bez względu na to, czy szukasz krótkiego spaceru, aby rozprostować
              nogi, czy ambitnej wędrówki przez górskie szczyty, wokół
              Dusznika-Zdrój znajdziesz coś dla siebie. Szlaki różnią się
              długością i stopniem trudności, więc każdy znajdzie coś
              odpowiedniego dla siebie.
            </p>
            <p>
              Zachęcamy do odwiedzenia{" "}
              <a
                href="https://www.komoot.com/pl-pl/guide/2628324/szlaki-piesze-woko-dusznik-zdroju"
                target="_blank"
              >
                przewodnika
              </a>{" "}
              , gdzie znajdziesz szczegółowe informacje o szlakach turystycznych
              wokół Dusznika-Zdrój. Niezależnie od tego, czy jesteś
              doświadczonym turystą, czy dopiero zaczynasz swoją przygodę z
              górskimi wędrówkami, zapewniamy, że odkryjesz tu coś wyjątkowego.
            </p>
          </SingleAttraction>
          <SingleAttraction
            title={services[6]}
            withBottomBorder={false}
            imagesSources={[muzeumPapiernictwa1, muzeumPapiernictwa2]}
          >
            <p>
              Papier jest tak ważny w naszej codzienności, a przy tym tak
              różnorodny! Kto z nas nie cieszy się z wyjątkowo udanego rysunku?
              W Dusznikach-Zdroju można o papierze dowiedzieć się wiele. Od
              wieków dokładnie w tym miejscu produkowano papier. Odwiedzający
              może i dziś zobaczyć jak ten proces wygląda. Zwiedzając{" "}
              <a href="https://muzeumpapiernictwa.pl/" target="_blank">
                muzeum
              </a>{" "}
              na żywo zobaczysz więc, jak wytwarza się papier metodą znaną od
              średniowiecza. Co więcej – uczestnicząc w warsztatach,
              samodzielnie wyczerpiesz swoją kartkę. Możesz także wziąć udział w
              innych praktycznych zajęciach rozwijających kreatywność,
              oczywiście z wykorzystaniem papieru. Spacer w okolicy muzeum
              zlokalizowanego tuż przy rzece Bystrzycy Dusznickiej jest wielką
              frajdą (zwłaszcza po deszczu gdyż można obserwować bystro płynącą
              wodę z pięknego mostku).
            </p>
          </SingleAttraction>
        </div>
      </div>
    </div>
  );
}
